import { ContentTypeEnum } from "@/static/dataType";

const data = {
  production: {
    title: "機能制約",
    headers: ["API動作", "制限値"],
    data: [
      {
        type: ContentTypeEnum.api,
        title: "API全体でのCall数制約",
        text: "100req / 1sec / IPアドレス",
      },
      {
        type: ContentTypeEnum.api,
        title: "ユーザー認証",
        text: "1000req / 15min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "アクセストークンのリフレッシュ",
        text: "1000req / 15min / アプリケーション<br/>リフレッシュトークン有効期限：30日",
      },
      {
        type: ContentTypeEnum.api,
        title: "アクセストークン取得",
        text: "1000req / 15min / アプリケーション<br/>アクセストークン有効期限：7日",
      },
      {
        type: ContentTypeEnum.api,
        title: "画像取得",
        text: "24req / 1min / アプリケーション & デバイス<br/>過去画像は、直近1分間は取得不可<br/>画素数：機種と設定によります。<br/>アスペクト比：16:9<br/>同時接続Client ID上限数：制限無し",
      },
      {
        type: ContentTypeEnum.api,
        title: "デバイス一覧取得",
        text: "200req / 15min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディア一覧取得",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "位置情報取得",
        text: "10req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "標準イベント一覧取得",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "サムネイル取得",
        text: "30req / 15min / アプリケーション & デバイス<br/>画素数：機種と設定によります。<br/>アスペクト比：機種と設定によります。",
      },
      {
        type: ContentTypeEnum.api,
        title: "スチルキャプチャ",
        text: "15req / 15min / アプリケーション & デバイス<br/>画素数：機種と設定によります。<br/>アスペクト比：デバイス依存",
      },
      {
        type: ContentTypeEnum.api,
        title: "シェア一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "シェア権限変更",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル 作成要求一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル 作成要求",
        text: "15req / 15min / アプリケーション & デバイス<br/>作成可能なメディアの長さ：1~10分<br/>作成可能なメディアの上限：60min / デバイス<br/>画素数：機種と設定によります。<br/>アスペクト比：機種と設定によります。<br/>fps： 30",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル 作成要求取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル 作成要求削除",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル ダウンロード",
        text: "30req / 15 min / アプリケーション & デバイス<br/>複数のダウンロード要求不可 / デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "HTTP Live Streamingプレイリスト取得",
        text: "15req / 1min / アプリケーション & デバイス<br/>アクセス：1 アプリケーション / 月 / デバイス<br/>プラン：トライアルとプラン：プロダクトは別枠の扱いとなり、それぞれで利用できます。ただし、プラン：トライアルでは、Safie SDK(JavaScript)のストリーミングプレイヤーとの共通枠となります。<br/>画素数：機種と設定によります。<br/>アスペクト比：機種と設定によります。<br/>fps：最大30fps<br/>遅延：Safie Viewerと同程度。3秒~5秒",
      },
      {
        type: ContentTypeEnum.api,
        title: "ムービークリップ一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "ムービークリップ取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "ムービークリップ ダウンロード",
        text: "制限なし<br/>複数のダウンロード要求不可 / デバイス<br/>画素数：機種と設定によります。<br/>アスペクト比：機種と設定によります。<br/>fps：最大30fps",
      },
      {
        type: ContentTypeEnum.api,
        title: "ムービークリップサムネイル ダウンロード",
        text: "24req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "アプリケーションリンク一覧取得",
        text: "200req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "アプリケーションリンク作成",
        text: "制限なし",
      },
      {
        type: ContentTypeEnum.api,
        title: "アプリケーションリンク削除",
        text: "制限なし",
      },
      {
        type: ContentTypeEnum.api,
        title: "API利用上限確認",
        text: "15req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "スナップショットのサムネイルダウンロード",
        text: "24req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "スナップショットダウンロード",
        text: "24req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "スナップショット一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "人物検出結果一覧の取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "イベント一覧取得",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "イベント登録",
        text: "12req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "顔認証端末一覧取得",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "入退場一覧取得",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "利用者一覧取得",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "利用者登録",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "利用者情報取得",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "利用者削除",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "利用者更新",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "利用者入室権限更新",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "入場権限一覧取得",
        text: "60req / 1min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "ユーザ情報取得",
        text: "200req / 15min / アプリケーション",
      },
      {
        type: ContentTypeEnum.api,
        title: "PTZ座標取得",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "PTZ座標移動",
        text: "60req / 60min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "PTZ中心点移動",
        text: "60req / 60min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "PTZプリセット一覧取得",
        text: "30req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "立ち入りカウント結果一覧取得",
        text: "60req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "通過人数カウント結果一覧取得",
        text: "60req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "立ち入り検知結果一覧取得",
        text: "60req / 1min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "立ち入りカウント設定一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "通過人数カウント設定一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
      {
        type: ContentTypeEnum.api,
        title: "立ち入り検知設定一覧取得",
        text: "60req / 15min / アプリケーション & デバイス",
      },
    ],
  },
  trial: {
    title: "トライアルプランでの使用上限",
    headers: ["API動作", "上限値 / 月 / デバイス"],
    data: [
      {
        type: ContentTypeEnum.api,
        title: "画像取得",
        text: "5万枚",
      },
      {
        type: ContentTypeEnum.api,
        title: "HTTP Live Streaming プレイリスト取得",
        text: "240時間（10日分）<br/>Safie SDK(JavaScript)のストリーミングプレイヤーと共用の制限となります。",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル 作成要求",
        text: "240時間（10日分）",
      },
      {
        type: ContentTypeEnum.api,
        title: "メディアファイル ダウンロード",
        text: "240時間（10日分）",
      },
      {
        type: ContentTypeEnum.api,
        title: "ムービークリップ ダウンロード",
        text: "240時間（10日分）",
      },
      {
        type: ContentTypeEnum.api,
        title: "スナップショットダウンロード",
        text: "5万枚 *1",
      },
      {
        type: ContentTypeEnum.api,
        title: "スナップショットのサムネイルダウンロード",
        text: "5万枚 *2",
      },
      {
        type: ContentTypeEnum.api,
        title: "その他機能",
        text: "制限なし",
      },
    ],
    tip: "*1 *2 の合計が最大5万枚/月となります。",
  },
  chooseList: {
    title: "オプション名一覧",
    headers: ["item_id", "オプション名", "内容"],
    data: [
      {
        title: "948",
        text: "静止画 API（10万枚）",
        text2: "Devices v2/画像取得　10万枚/月",
      },
      {
        title: "949",
        text: "静止画 API（50万枚）",
        text2: "Devices v2/画像取得　50万枚/月",
      },
      {
        title: "950",
        text: "静止画 API（100万枚）",
        text2: "Devices v2/画像取得　100万枚/月",
      },
      {
        title: "951",
        text: "静止画 API（200万枚）",
        text2: "Devices v2/画像取得　200万枚/月",
      },
      {
        title: "952",
        text: "ストリーミング API",
        text2:
          "Live v2/HTTP Live Streamingプレイリスト取得　1アプリケーションからの接続/月",
      },
      {
        title: "954",
        text: "メディアファイル API（32日）",
        text2:
          "Media Files v2/メディアファイル作成要求　32日分/月<br/>Media Files v2/メディアファイルダウンロード　32日分/月",
      },
      {
        title: "955",
        text: "メディアファイル API（64日）",
        text2:
          "Media Files v2/メディアファイル作成要求　64日分/月<br/>Media Files v2/メディアファイルダウンロード　64日分/月",
      },
      {
        title: "959",
        text: "スチルキャプチャ API",
        text2: "Devices v2/スチルキャプチャ　制限なし",
      },
      {
        title: "960",
        text: "AI People Count API",
        text2: "AI People Count v2/人物検出結果一覧の取得　制限なし",
      },
      {
        title: "973",
        text: "位置情報取得 API",
        text2: "Devices v2/位置情報取得　制限なし",
      },
      {
        title: "997",
        text: "ムービークリップ（32日）＆スナップショット（10万枚）DL API",
        text2:
          "Movie Clips v2/ムービークリップ　ダウンロード 32日/月<br/>Snapshots v2/スナップショットダウンロード<br/>Snapshots v2/スナップショットのサムネイルダウンロード　10万枚/月",
      },
      {
        title: "1049",
        text: "外部イベント登録 API",
        text2: "Events v2/イベント登録　制限なし",
      },
      {
        title: "1050",
        text: "基本機能 API",
        text2:
          "Devices v2/デバイス一覧取得　制限なし<br />Devices v2/メディア一覧取得　制限なし<br />Devices v2/サムネイル取得　制限なし<br />Devices v2/標準イベント一覧取得　制限なし<br />Quotas v2/API利用上限確認　制限なし<br />Shares v2/シェア一覧取得　制限なし<br />Shares v2/シェア権限変更　制限なし<br />※基本機能APIオプション以外が付与されている場合も、これらの機能は利用できます",
      },
      {
        title: "1252",
        text: "AI-App 人数カウント API",
        text2:
          "AI-App People Count/立ち入りカウント設定一覧取得　制限なし<br />AI-App People Count/立ち入りカウント結果一覧取得　制限なし<br />AI-App People Count/通過人数カウント設定一覧取得　制限なし<br />AI-App People Count/通過人数カウント結果一覧取得　制限なし<br />AI-App People Count/立ち入り検知設定一覧取得　制限なし<br />AI-App People Count/立ち入り検知結果一覧取得　制限なし",
      },
      {
        title: "1386",
        text: "PTZ API",
        text2:
          "PTZ/PTZ座標取得　制限なし<br />PTZ/PTZ座標移動　制限なし<br />PTZ/PTZ中心点移動　制限なし<br />PTZ/PTZプリセット一覧取得　制限なし",
      },
      {
        title: "5 *",
        text: "Entrance API",
        text2:
          "Entrance v2　制限なし<br/>* デバイスではなく企業アカウントに対して付与するオプションです。",
      },
    ],
  },
};

const context = {
  headerTitle: "API 機能制約",
  headerIcon: require("./images/header-icon.svg"),
  data,
};
export default context;
